import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";
import FlowRedirect from "./FlowRedirect";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.PROCESSES.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PROCESS]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={List}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.PROCESSES.CREATE.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PROCESS]: SUBMODULES.ADMIN_CREATE }}
        WrappedComponent={Create}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PROCESSES.DETAIL.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PROCESS]: SUBMODULES.ADMIN_DETAIL }}
        WrappedComponent={Detail}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PROCESSES.FLOW_LEGACY.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PROCESS]: SUBMODULES.ADMIN_DETAIL }}
        WrappedComponent={FlowRedirect}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PROCESSES.DELETE.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PROCESS]: SUBMODULES.ADMIN_DELETE }}
        WrappedComponent={Delete}
      />
    ),
  },
];

export default routes;
